export class SliderDto {
    id: number;
    title: string;
    content: string;
    imageUrl: string;
    selectedFileBase64: string;
    text1?: string;
    link1?: string;
    text2?: string;
    link2?: string;
  
    constructor(
      id: number,
      title: string,
      content: string,
      imageUrl: string,
      selectedFileBase64: string,
      text1: string,
      link1: string,
      text2: string,
      link2: string,
    ) {
      this.id = id;
      this.title = title;
      this.content = content;
      this.imageUrl = imageUrl;
      this.selectedFileBase64 = selectedFileBase64;
      this.text1 = text1;
      this.text2 = text2;
      this.link1 = link1;
      this.link2 = link2;
    }
  }
  